import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../components/Layout'
import NavbarLayout from '../components/NavbarLayout'
import Connection from '../views/Connection'
import Instance from '../views/Instance'
import TemplateList from '../views/TemplateList'
import InstanceList from '../views/InstanceList'
import Template from '../views/Template'
import TemplateSessions from '../views/TemplateSessions'
import SessionDetail from '../views/SessionDetail'
import SessionReport from '../components/SessionReport'
import FirstRoundEnd from '../views/FirstRoundEnd'
import SecondRoundEnd from '../views/SecondRoundEnd'
import store from 'store'
import axios from 'axios'

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    routes: [
        {
            path: '/opigno-endpoint/:mode/:instanceId/:token/:refreshToken',
            name: 'OpignoEndpoint',
            beforeEnter: (to, from, next) => {
                store.commit("OPIGNO_MODE_UPDATED", to.params.mode);
                store.commit("TOKEN_UPDATED", {newToken: to.params.token, newRefreshToken: to.params.refreshToken});
                next({name:"Instance", params: {instanceId: to.params.instanceId}});
            }
        },
        {
            path: '/',
            component: Layout,
            children: [
                {
                    path: '',
                    name: 'Connection',
                    component: Connection
                },
                {
                    path: 'user',
                    component: NavbarLayout,
                    children: [
                        {
                            path: 'instances',
                            name: 'InstanceList',
                            component: InstanceList
                        },
                        {
                            path: 'instance/:instanceId',
                            name: 'Instance',
                            component: Instance,
                            beforeEnter: (to, from, next) => {
                                store.dispatch("getInstance", {
                                    instanceId: to.params.instanceId,
                                    callbacks: {
                                        success: (data) => {
                                            store.commit("INIT_INSTANCE", data);
                                            let currentStep = data.instance.currentStep.step;
                                            if (store.state.opignoMode == 1 
                                                && (currentStep == 'SECOND_STEP'
                                                    || currentStep == 'SATISFACTION_SURVEY'
                                                    || currentStep == 'END'))   {
                                                next({name: 'FirstRoundEnd'});
                                            }
                                            else if (store.state.opignoMode == 2 
                                                    && currentStep == 'END')   {
                                                next({name: 'SecondRoundEnd'});
                                            } 
                                            next();
                                        },
                                        fail: () => {
                                            next("/");
                                        },
                                        error: () => {
                                            next("/");
                                        }
                                    }
                                });
                            }
                        },
                        {
                            path: 'first-round-end',
                            name: 'FirstRoundEnd',
                            component: FirstRoundEnd
                        },
                        {
                            path: 'second-round-end',
                            name: 'SecondRoundEnd',
                            component: SecondRoundEnd
                        }
                    ]
                },
                {
                    path: 'admin',
                    component: NavbarLayout,
                    children: [
                        {
                            path: 'templates',
                            name: 'TemplateList',
                            component: TemplateList,
                            beforeEnter: (to, from, next) => {
                                store.dispatch("getTemplateList", {callbacks: {
                                    success: (data) => {
                                        store.commit("INIT_TEMPLATE_LIST", data);
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                }});
                            }
                        },
                        {
                            path: 'template/create',
                            name: 'TemplateCreate',
                            component: Template,
                            meta: {mode: 'create'},
                            beforeEnter: (to, from, next) => {
                                store.dispatch("getDefaultTemplate", {
                                    success: (data) => {
                                        data['defaultTemplate'] = false;
                                        data['id'] = false;
                                        store.commit("INIT_CURRENT_TEMPLATE", data);
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                });
                            }
                        },
                        {
                            path: 'template/:templateId',
                            name: 'TemplateEdit',
                            component: Template,
                            meta: {mode: 'edit'},
                            beforeEnter: (to, from, next) => {
                                store.dispatch("getTemplate", {
                                    templateId: to.params.templateId,
                                    callbacks: {
                                        success: (data) => {
                                            store.commit("INIT_CURRENT_TEMPLATE", data);
                                            next();
                                        },
                                        fail: () => {
                                            next("/");
                                        },
                                        error: () => {
                                            next("/");
                                        }
                                    }
                                });
                            }
                        },
                        {
                            path: 'template/default',
                            name: 'TemplateDefault',
                            component: Template,
                            meta: {mode: 'default'},
                            beforeEnter: (to, from, next) => {
                                store.dispatch("getDefaultTemplate", {
                                    success: (data) => {
                                        store.commit("INIT_CURRENT_TEMPLATE", data);
                                        next();
                                    },
                                    fail: () => {
                                        next("/");
                                    },
                                    error: () => {
                                        next("/");
                                    }
                                });
                            }
                        },
                        {
                            path: 'template/:templateId/sessions',
                            name: 'TemplateSessions',
                            component: TemplateSessions,
                            beforeEnter: (to, from, next) => {
                                store.dispatch("getParentsTargetInstance", {
                                    templateId: to.params.templateId,
                                    callbacks: {
                                        success: (data) => {
                                            store.commit("INIT_SESSIONS_TEMPLATE", data);
                                            next();
                                        },
                                        fail: () => {
                                            next("/");
                                        },
                                        error: () => {
                                            next("/");
                                        }
                                    }
                                });
                            }
                        },
                        {
                            path: 'template/:templateId/session/:sessionId',
                            name: 'SessionDetail',
                            component: SessionDetail,
                            beforeEnter: (to, from, next) => {
                                store.dispatch("getParentTargetInstance", {
                                    parentTargetInstanceId: to.params.sessionId,
                                    callbacks: {
                                        success: (data) => {
                                            store.commit("INIT_SESSION", data);
                                            next();
                                        },
                                        fail: () => {
                                            next("/");
                                        },
                                        error: () => {
                                            next("/");
                                        }
                                    }
                                });
                            }
                        },
                        {
                            path: 'template/:templateId/session/:sessionId/report',
                            name: 'SessionReport',
                            component: SessionReport,
                            beforeEnter: (to, from, next) => {
                                store.dispatch("getParentTargetInstance", {
                                    parentTargetInstanceId: to.params.sessionId,
                                    callbacks: {
                                        success: (data) => {
                                            store.commit("INIT_SESSION", data);
                                            next();
                                        },
                                        fail: () => {
                                            next("/");
                                        },
                                        error: () => {
                                            next("/");
                                        }
                                    }
                                });
                            }
                        }
                    ]
                }
            ]
        }
    ]
});

export default router;
